<div id="subcontainer">
    <div id="subheadpopup">
      <h2 id="subtext" class="firsttext">Add Sub Head Code </h2>
      <i class="fa fa-times-circle fa-lg" id="closeimage" (click)="close()"></i>
      <form action="" [formGroup]="subhead">
        <span id="selectsubhead">
          <mat-label class="fonttext">Select Sub Head Code</mat-label>
            
              <mat-select class="intbtn" formControlName="headControl2" placeholder="">   
                <input matInput [matAutocomplete]="headControlauto" [formControl]="headControl"  class="inputborderpopup"
                placeholder="" class="orginput">
              <mat-autocomplete autoActiveFirstOption #headControlauto="matAutocomplete"></mat-autocomplete>
              <mat-option *ngFor="let item of headOptions | async" [value]="item.transHeadId"
                (click)="headCode(item)" [disabled]="addedlist.includes(item.transHeadId)">{{ item.headName }}</mat-option>
            </mat-select>              
        </span>
        <span id="headamount">
          <mat-label class="fonttext fonttext">Head Amount (₹)</mat-label>
          <input class="input" id="headtext"  placeholder=""  formControlName="headAmount" >
        </span>
        <span id="headorganization">
          <mat-label class="fonttext">Head Organisation</mat-label>
          <mat-select class="intbtn"  formControlName="organisationControl2" class="headorganization"  placeholder='' >
            <input matInput [matAutocomplete]="organisationauto" [formControl]="organisationcontrol" class="inputborder"
              placeholder="select organisation" class="orginput">
            <mat-autocomplete autoActiveFirstOption #organisationauto="matAutocomplete">
            </mat-autocomplete>
            <mat-option *ngFor="let item of organisationOptions2| async ; let i = index" [value]="item.orgId" (click)="org(item)">{{item.orgName}}</mat-option>
          </mat-select>
        </span>
        <span id="finanace" class="secondpart ">
          <h3 class="popupText firsttext ">Finance Details</h3>
          <table id="Finance">
            <tr>
              <td class="finanacetd fonttext" ><mat-label>Payment Model</mat-label></td>
              <td class="finanacetd">
                <mat-select class="inputborderpopup" placeholder=""formControlName="headCalculationType2">
                  <input matInput [matAutocomplete]="paymentModelsOptionsauto" [formControl]="headCalculationType"
                    class="inputborderpopup orginput" placeholder="select paymentModel" >
                  <mat-autocomplete autoActiveFirstOption #paymentModelsOptionsauto="matAutocomplete">
  
                  </mat-autocomplete>
                  <mat-option *ngFor="let item of paymentModelsOptions | async ;let i=index " [value]="i">{{item.displayName}}</mat-option>
                </mat-select>           
              </td>
            </tr>
            <tr>
              <td class="finanacetd fonttext"><mat-label>Concession Model</mat-label></td>
              <td class="finanacetd fonttext">
                <mat-select class="inputborderpopup" placeholder=""formControlName="conHeadCalculationType2">
                  <input matInput [matAutocomplete]="paymentModelsOptionsauto"  [formControl]="conHeadCalculationType"
                    class="orginput inputborderpopup" placeholder="select paymentModel">
                  <mat-autocomplete autoActiveFirstOption #paymentModelsOptionsauto="matAutocomplete">
  
                  </mat-autocomplete>
                  <mat-option *ngFor="let item of paymentModelsOptions2 | async;let i=index " [value]="i">{{item.displayName}}</mat-option>
                </mat-select>
               
             
              </td>
            </tr>
            <tr>
              <td class="finanacetd fonttext"><mat-label>Deduction Model</mat-label></td>
              <td class="finanacetd fonttext">
                <mat-select class="inputborderpopup"placeholder="" formControlName="deductCalculationType2"
                   >
                  <input matInput [matAutocomplete]="paymentModelsOptionsauto"  [formControl]="deductCalculationType"
                    class="orginput inputborderpopup" placeholder="select deduction  paymentModel">
                  <mat-autocomplete autoActiveFirstOption #paymentModelsOptionsauto="matAutocomplete">
  
                  </mat-autocomplete>
                  <mat-option *ngFor="let item of paymentModelsOptions3 |async ;let i=index " [value]="i">{{item.displayName}}</mat-option>
                </mat-select>
                
                
              </td>
            </tr>
            <tr>
            <tr>
              <td class="finanacetd fonttext "><mat-label>App Fee</mat-label></td>
              <td class="finanacetd fonttext">
                <mat-select formControlName="appFee" placeholder="" class="inputborderpopup" >
                  <mat-option  value="option1" >Yes</mat-option>
                  <mat-option  value="option2" >No</mat-option>
                </mat-select>
              </td>
            </tr>
            <tr>
              <td class="finanacetd fonttext"><mat-label>Allow Additional Amount</mat-label></td>
              <td class="finanacetd fonttext">
                <mat-select formControlName="allowAdditionalAmount" class="intbtn" placeholder="" class="inputborderpopup">
                  <mat-option  value="option1">Yes</mat-option>
                  <mat-option  value="option2">No</mat-option>
                </mat-select>
                
               
              </td>
            </tr>
            <tr>
              <td class="finanacetd fonttext"><mat-label>Allow Excess Amount</mat-label></td>
              <td class="finanacetd fonttext">
                <mat-select formControlName="allowExcessAmount" placeholder="" class="inputborderpopup">
                  <mat-option  value="option1">Yes</mat-option>
                  <mat-option  value="option2">No</mat-option>
                </mat-select>
            
     
              </td>
            </tr>
          
          </table>
        </span>
        <span id="tax" class="secondpart  ">
          <h3 class="popupText ">Tax</h3>
          <table id="Finance ">
            <tr>
              <td class="finanacetd firsttext"><mat-label>Tax Type</mat-label></td>
              <td class="finanacetd fonttext inputborderpopup"> 
                <mat-select [value]="3" class="inputborderpopup" >
                  <mat-option [value]="1" (click)="tax('taxInclusive')">taxInclude</mat-option>
                  <mat-option [value]="2" (click)="tax('taxExclusive')">taxExclude</mat-option>
                  <mat-option [value]="3" (click)="tax('notax')">No Tax</mat-option>
                </mat-select></td>
            </tr>
            <tr>
              <td class="finanacetd  fonttext"><mat-label>State Tax(%)</mat-label></td>
              <td class="finanacetd  fonttext"><input type="text" [value]="stateGstRate"  class="text-right" readonly class="inputborderpopup subinput taxinput"></td>
            </tr>
            <tr>
              <td class="finanacetd fonttext"><mat-label>Central Tax(%)</mat-label></td>
              <td class="finanacetd fonttext"><input type="text" [value]="centralGstRate"  class="text-right"
                readonly class="inputborderpopup taxinput subinput"></td>
            </tr>
            <tr>
              <td class="finanacetd fonttext"><mat-label>Total Tax</mat-label></td>
              <input type="text" [value]="totalGstRate"class="inputborderpopup taxinput subinput text-right"  readonly id="total">
            </tr>
          </table>
        </span>
        <span id="priorityorder" class="thirdpart ">
          <h3 class="popupText firsttext">Priority Order</h3>
          <table id="Finance">
            <tr>
              <td class="finanacetd fonttext"><mat-label>App Sales </mat-label></td>
              <td class="finanacetd fonttext">
                <mat-select class="inputborderpopup"formControlName="appSales2"placeholder= ""  >
                  <input matInput [matAutocomplete]="priorityNameauto" [formControl]="appSales"
                    class="orginput inputborderpopup" placeholder="select priorityName">
                  <mat-autocomplete autoActiveFirstOption #priorityNameauto="matAutocomplete">
  
                  </mat-autocomplete>
                  <mat-option *ngFor="let item of priorityNameOptions1 | async;let i=index " [value]="i">{{item.priorityName}}</mat-option>
                </mat-select>
              
               
              </td>
            </tr>
            <tr>
              <td class="finanacetd fonttext"><mat-label>Concession </mat-label></td>
              <td class="finanacetd fonttext">
                <mat-select class="inputborderpopup"placeholder= "" formControlName="conPriority2"placeholder="">
                  <input matInput [matAutocomplete]="priorityNameauto"  [formControl]="conPriority"
                    class="orginput inputborderpopup" placeholder="select priorityName">
                  <mat-autocomplete autoActiveFirstOption #priorityNameauto="matAutocomplete">
  
                  </mat-autocomplete>
                  <mat-option *ngFor="let item of priorityNameOptions2 | async ;let i=index " [value]="i" >{{item.priorityName}}</mat-option>
                </mat-select>
               
             
              </td>
            </tr>
            <tr>
              <td class="finanacetd fonttext"><mat-label>Payment</mat-label></td>
              <td class="finanacetd fonttext">
                <mat-select class="inputborderpopup"placeholder= "Zero Priority"formControlName="priority2"placeholder="">
                  <input matInput [matAutocomplete]="priorityNameauto"  [formControl]="priority"
                    class="orginput inputborderpopup" placeholder="select priorityName">
                  <mat-autocomplete autoActiveFirstOption #priorityNameauto="matAutocomplete">
  
                  </mat-autocomplete>
                  <mat-option *ngFor="let item of priorityNameOptions4 | async;let i=index " [value]="i">{{item.priorityName}}</mat-option>
                </mat-select>
             
            
              </td> 
            </tr>
            <tr>
              <td class="finanacetd fonttext"><mat-label>Deduction</mat-label></td>
              <td class="finanacetd fonttext">
                <mat-select class="inputborderpopup"placeholder= "Zero Priority"formControlName="deductPriority2"placeholder="" >
                  <input matInput [matAutocomplete]="priorityNameauto"  [formControl]="deductPriority"
                    class="orginput inputborderpopup" placeholder="select priorityName">
                  <mat-autocomplete autoActiveFirstOption #priorityNameauto="matAutocomplete">
  
                  </mat-autocomplete>
                  <mat-option *ngFor="let item of priorityNameOptions3 | async;let i=index " [value]="i">{{item.priorityName}}</mat-option>
                </mat-select>
               
                
              </td>
            </tr>
          </table>
        </span>
        <span id="reciept" class="thirdpart  ">
          <h3 class="popupText firsttext">Reciepts Print Details</h3>
          <table id="Finance ">
            <tr>
              <td class="finanacetd fonttext"><mat-label>Display Name</mat-label></td> 
              <td class="finanacetd fonttext">
                <input type="text" class="subinput"  formControlName="displayName"class="inputborderpopup subinput display"placeholder="" >
              
               
              </td>
            </tr>
            <tr>
              <td class="finanacetd fonttext"><mat-label>Course Display</mat-label></td>
              <td class="finanacetd fonttext">
                <input type="text"formControlName="courseDisplay"  class="inputborderpopup subinput display"placeholder="" >
            
                
              </td>
            </tr>
            <tr>
              <td class="finanacetd fonttext"><mat-label>Reciept Type</mat-label></td>
              <td class="finanacetd fonttext ">
                <mat-select class="inputborderpopup size" placeholder="" formControlName="receiptsType2">
                  <input matInput [matAutocomplete]="receiptTypesOptionsauto"  [formControl]="receiptsType"
                    class="orginput inputborderpopup" placeholder="">
                  <mat-autocomplete autoActiveFirstOption #receiptTypesOptionsauto="matAutocomplete">
                  </mat-autocomplete>
                  <mat-option *ngFor="let item of receiptTypesOptions | async;let i=index " [value]="item.displayName">{{item.displayName}}</mat-option>             
                </mat-select>
            

              </td>
            </tr>
          </table>
        </span>
        <span id="footerhr"></span>
        <button type="submit"  id="save" (click)="save()">Save</button>

      </form>

    </div>
  </div>
     <!-- =======Loading ========== -->

     <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
        <p style="font-size: 20px; color: white">Loading...</p>
    </ngx-spinner>